import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setShowCreateProfileModal, setProfile } from "../store";
import { checkAuth } from "../utils/authService";
import API_SERVICE from "../utils/apiService";

export function useDebounce(callback, dependencies, delay = 300) {
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);
  useEffect(() => {
    const handler = setTimeout(() => {
      callbackRef.current();
    }, delay);
    return () => clearTimeout(handler);
    // eslint-disable-next-line
  }, [...dependencies, delay]);
}

export function useAuthFlow() {
  const dispatch = useDispatch();
  const username = useSelector((state) => state.user.profile.username);

  useEffect(() => {
    const triggerAuthFlow = async () => {
      const isAuthenticated = await checkAuth();
      if (!isAuthenticated) {
        return; // case 1. not logged in.
      }
      // if authenticated, try to load profile
      let profile = await API_SERVICE.getProfile();
      if (!profile) {
        dispatch(setShowCreateProfileModal(true));
        return; // case 2. logged in, no profile.
      } else {
        dispatch(setProfile(profile));
        return; // case 3. already logged in with profile.
      }
    };
    triggerAuthFlow();
  }, [username, dispatch]);
}
